import { render, staticRenderFns } from "./TableWithSearch.vue?vue&type=template&id=1a578d97&scoped=true&"
import script from "./TableWithSearch.vue?vue&type=script&lang=js&"
export * from "./TableWithSearch.vue?vue&type=script&lang=js&"
import style0 from "./TableWithSearch.vue?vue&type=style&index=0&id=1a578d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a578d97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
